import { Mail, MapPin, Phone } from "lucide-react";
import { CONTATO } from "@/data/acomodacoes";
import { Reveal, Eyebrow } from "@/components/Motion";

export const Contato = () => (
  <section id="contato" data-testid="contact-section" className="bg-[#f4f0e6] py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-12">
      <Reveal className="lg:col-span-5">
        <Eyebrow>Contato</Eyebrow>
        <h2 className="text-3xl font-bold leading-[1.05] tracking-[-0.03em] text-[#1a382b] sm:text-5xl">Venha nos visitar.</h2>
        <ul className="mt-10 space-y-6 text-[#263228]">
          <li className="flex gap-4">
            <MapPin className="mt-1 h-5 w-5 shrink-0 text-[#a85d38]" />
            <span data-testid="contact-address">{CONTATO.endereco}</span>
          </li>
          <li className="flex gap-4">
            <Phone className="mt-1 h-5 w-5 shrink-0 text-[#a85d38]" />
            <a data-testid="contact-whatsapp-link" href={`https://wa.me/${CONTATO.whatsapp}`} target="_blank" rel="noreferrer" className="hover:text-[#a85d38]">
              {CONTATO.telefone} (WhatsApp)
            </a>
          </li>
          <li className="flex gap-4">
            <Mail className="mt-1 h-5 w-5 shrink-0 text-[#a85d38]" />
            <a data-testid="contact-email-link" href={`mailto:${CONTATO.email}`} className="break-all hover:text-[#a85d38]">
              {CONTATO.email}
            </a>
          </li>
        </ul>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-7">
        <iframe
          data-testid="contact-map"
          title="Mapa Quinta dos Pinhais"
          src="https://www.google.com/maps?q=Quinta+dos+Pinhais+Estrada+Pico+Agudo+Santo+Antonio+do+Pinhal&output=embed"
          className="h-[360px] w-full border-0 grayscale-[35%] sm:h-[460px]"
          loading="lazy"
        />
      </Reveal>
    </div>
  </section>
);
